import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';
import tplHelpers from "../../../helpers/tpl";
import Get3PLShipmentConfirmationTable from './Get3PLShipmentConfirmationTable';
import OrderDetails from './OrderDetails';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';


function Get3PLShipmentConfirmation(props) {

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [orders, setOrders] = useState([]);
    const [direction, setDirection] = useState(null);
    const [detailsTab, setDetailsTab] = useState(null);
    const [cleared, setCleared] = useState(false);
    const [openDetails, setOpenDetail] = useState(null);

    useEffect(() => {
        if (cleared) {
        const timeout = setTimeout(() => {
            setCleared(false);
        }, 1500);

        return () => clearTimeout(timeout);
        }
        return () => {};
    }, [cleared]);

    const get3PLShipmentConfirmation = async() => {
        props.setLoading(true);
        try {
            let downloaded_orders = await tplHelpers.get3PLShipmentConfirmation(startDate, endDate, props.company, props.token);
            console.log(downloaded_orders);
            setOrders(downloaded_orders.data.data.body.response.order);
        } catch (error) {
            console.error("Error getting 3PL shipment confirmation:", error);
        } finally {
            props.setLoading(false);
        }
    };

    const setOpenDetails = async(order = {}) => {
        if(Object.keys(order)?.length === 0 ) {
            setOpenDetail(order);
            setDetailsTab(0);
        }
        else {
            setOpenDetail(order.row);
            setDetailsTab(0)
        }
    }

    const setTab = async(e) => {
        console.log(e);
        let tab = Number(e.target.name);
        if(tab > detailsTab) setDirection("left");
        else setDirection("right")
        setDetailsTab(tab);
    }

    return (
        <Box className={props.isMobile ? "mobile-top" : "desktop-top"} sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box className={props.isMobile ? "mobile-box" : "desktop-box"}>
                <h1>Shipping Confirmation</h1> 
                <Stack direction = "row" alignItems = {"center"}>
                    <FormControl sx = {{ mr: '10px', width: '20%' }}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                label="Start Date"
                                name='startDate'
                                onChange={(e) => setStartDate(e)}
                                value={startDate ? startDate : null}
                                renderInput={(params) => <TextField {...params} />}
                                clearable={true}
                            />
                        </LocalizationProvider>
                    </FormControl>
                    <FormControl sx = {{ mr: '10px', width: '20%' }}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                                label="End Date"
                                name='endDate'
                                onChange={(e) => setEndDate(e)}
                                value={endDate ? endDate : null}
                                renderInput={(params) => <TextField {...params} />}
                                clearable={true}
                            />
                        </LocalizationProvider>
                    </FormControl>
                    <Button
                        className={`${props.company} ${props.warehouse} secondary`}
                        variant="contained"
                        onClick={() => get3PLShipmentConfirmation()}
                        sx={{
                            height: '40px', // Same height as the TextField
                        }}
                    >
                        Get Confirmation
                    </Button>
                </Stack>
                <OrderDetails 
                    {...props} 
                    direction = {direction} 
                    setTab = {setTab} 
                    tab = {detailsTab} 
                    order = {openDetails} 
                    setOpenDetails = {setOpenDetails} 
                />
                <Get3PLShipmentConfirmationTable 
                    isMobile = {props.isMobile}
                    orders = {orders}
                    setOpenDetails = {setOpenDetails}
                />
            </Box>
        </Box>
    )
    
}

export default Get3PLShipmentConfirmation;